'use client'
import {
  NotifyButton_default
} from "./chunk-WZIEBXDX.mjs";
import {
  Countdown_default
} from "./chunk-CGCU6FO5.mjs";
import {
  CollapsableText_default
} from "./chunk-MAJWJHOB.mjs";
import {
  ContentfulRichText_default
} from "./chunk-DR2RGIIC.mjs";
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  ShareContentfulButton_default
} from "./chunk-ALSTKEM5.mjs";
import {
  ContentfulButton_default
} from "./chunk-K3ITZBKW.mjs";
import {
  ContentfulMedia_default
} from "./chunk-BYRNGPWN.mjs";

// src/components/hero/HeroSection.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var HeroSection = ({ section }) => {
  const card = section.contentCollection.items[0];
  if (!card) return null;
  const desktopImage = card.image31 || card.background;
  const mobileImage = card.image11 || card.background;
  return /* @__PURE__ */ jsx("section", { id: section.id, children: /* @__PURE__ */ jsxs("div", { className: "from-body/60 to-body relative flex min-h-screen flex-col justify-between from-10% via-transparent via-20% before:absolute before:inset-0 before:-z-10 before:bg-gradient-to-b", children: [
    desktopImage && /* @__PURE__ */ jsx(
      ContentfulMedia_default,
      {
        media: desktopImage,
        poster: desktopImage == null ? void 0 : desktopImage.url,
        className: "absolute -z-20 hidden h-full w-full object-cover sm:block",
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        ratio: "3x1",
        placeholder: true
      }
    ),
    mobileImage && /* @__PURE__ */ jsx(
      ContentfulMedia_default,
      {
        media: mobileImage,
        poster: mobileImage == null ? void 0 : mobileImage.url,
        className: "absolute -z-20 h-full w-full object-cover sm:hidden",
        ratio: "1x1",
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        placeholder: true
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "container flex min-h-[calc(100vh-100px)] flex-col items-start justify-end gap-10 pb-20 lg:flex-row lg:items-end lg:justify-between", children: [
      /* @__PURE__ */ jsxs("div", { className: "w-full max-w-3xl space-y-2 pt-32 sm:pt-0", children: [
        card.icon && /* @__PURE__ */ jsx("div", { className: "shrink-0 pb-2", children: /* @__PURE__ */ jsx(
          ContentfulMedia_default,
          {
            media: card.icon,
            width: 100,
            height: 100,
            className: "object-contain"
          }
        ) }),
        /* @__PURE__ */ jsx("h1", { className: "text-4xl lg:flex-1 lg:text-7xl", children: card.title }),
        card.subtitle && /* @__PURE__ */ jsx("p", { className: "text-lg font-semibold lg:text-xl", children: card.subtitle }),
        card.description && /* @__PURE__ */ jsx(CollapsableText_default, { text: card.description, className: "text-sm" })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "flex flex-wrap items-center gap-2 text-sm md:gap-5 md:text-base lg:flex-1 lg:justify-end", children: section.webLinksCollection.items.map((link) => /* @__PURE__ */ jsx(ContentfulButton_default, { link, phill: true }, link.id)) })
    ] })
  ] }) });
};
var HeroSection_default = HeroSection;

// src/components/hero/HeroCounter.tsx
import { Typography } from "@wbk/ui";
import { Fragment, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var HeroCounterSection = ({ section }) => {
  var _a, _b, _c, _d;
  const first = (_a = section.contentCollection.items) == null ? void 0 : _a[0];
  const item = (first == null ? void 0 : first.__typename) === "Product" ? first : void 0;
  const title = (item == null ? void 0 : item.title) || section.title;
  const subtitle = section.subtitle;
  const logo = ((_b = item == null ? void 0 : item.kv) == null ? void 0 : _b.logo) || section.logo;
  const startAt = (_c = item == null ? void 0 : item.schedule) == null ? void 0 : _c.openDateTime;
  const started = !startAt || new Date(startAt) < /* @__PURE__ */ new Date();
  const links = (_d = section == null ? void 0 : section.webLinksCollection) == null ? void 0 : _d.items;
  return /* @__PURE__ */ jsx2(DecoratedSection_default, { section, className: "overflow-hidden", children: /* @__PURE__ */ jsxs2("div", { className: "container relative z-10 space-y-6 text-center", children: [
    logo && /* @__PURE__ */ jsx2(ContentfulMedia_default, { media: logo, className: "mx-auto" }),
    /* @__PURE__ */ jsxs2("div", { className: "space-y-2", children: [
      /* @__PURE__ */ jsx2(Typography, { as: "h1", variant: "display-M", children: title }),
      subtitle && /* @__PURE__ */ jsx2(Typography, { as: "h2", children: subtitle })
    ] }),
    !started && /* @__PURE__ */ jsxs2(Fragment, { children: [
      /* @__PURE__ */ jsx2(Countdown_default, { finishDate: startAt }),
      links && links.length > 0 ? /* @__PURE__ */ jsx2("div", { className: "flex flex-wrap justify-center gap-4", children: links.map((link) => /* @__PURE__ */ jsx2(ContentfulButton_default, { link }, link.id)) }) : item ? /* @__PURE__ */ jsx2(NotifyButton_default, { event: item, className: "min-h-0 max-w-sm py-3" }) : null
    ] })
  ] }) });
};
var HeroCounter_default = HeroCounterSection;

// src/components/hero/HeroGrid.tsx
import { Typography as Typography2 } from "@wbk/ui";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var HeroGrid = ({ section }) => {
  var _a, _b, _c;
  const card = (_b = (_a = section.contentCollection) == null ? void 0 : _a.items) == null ? void 0 : _b[0];
  const links = (_c = section.webLinksCollection) == null ? void 0 : _c.items;
  if (!card) return null;
  return /* @__PURE__ */ jsx3(DecoratedSection_default, { section, children: /* @__PURE__ */ jsxs3("div", { className: "container flex min-h-96 w-full flex-col-reverse items-center justify-center gap-8 lg:flex-row", children: [
    /* @__PURE__ */ jsxs3("div", { className: "grow space-y-4 py-6", children: [
      section.logo && /* @__PURE__ */ jsx3(ContentfulMedia_default, { media: section.logo }),
      /* @__PURE__ */ jsx3(Typography2, { variant: "heading-XL", children: card.title }),
      card.subtitle && /* @__PURE__ */ jsx3(Typography2, { variant: "body-L", children: card.subtitle }),
      !!links.length && /* @__PURE__ */ jsx3("ul", { className: "flex flex-wrap items-center gap-2", children: links.map((link) => /* @__PURE__ */ jsx3(ContentfulButton_default, { link }, link.id)) })
    ] }),
    (card == null ? void 0 : card.image) && /* @__PURE__ */ jsx3("div", { className: "shrink", children: /* @__PURE__ */ jsx3(ContentfulMedia_default, { media: card.image, className: "w-full max-w-full" }) })
  ] }) });
};
var HeroGrid_default = HeroGrid;

// src/components/hero/HeroImage.tsx
import { useMemo, useState } from "react";
import { Button, Carousel, Typography as Typography3 } from "@wbk/ui";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var HeroImage = ({ section }) => {
  var _a;
  const cards = section.contentCollection.items;
  const tags = section.tagsCollection.items;
  const [selectedTag, setSelectedTag] = useState((_a = tags == null ? void 0 : tags[0]) != null ? _a : null);
  const card = useMemo(() => {
    if (!(cards == null ? void 0 : cards.length)) return null;
    if (!tags.length) return cards[0];
    return cards.find(
      (card2) => {
        var _a2, _b;
        return (_b = (_a2 = card2.cmsTagsCollection) == null ? void 0 : _a2.items) == null ? void 0 : _b.find((tag) => tag.id === (selectedTag == null ? void 0 : selectedTag.id));
      }
    );
  }, [cards, selectedTag, tags.length]);
  if (!card) return null;
  const desktopImage = card.image31 || card.background;
  const mobileImage = card.image11 || card.background;
  return /* @__PURE__ */ jsxs4(
    DecoratedSection_default,
    {
      section,
      className: (tags == null ? void 0 : tags.length) ? "container !space-y-0" : "!space-y-0",
      children: [
        !!(tags == null ? void 0 : tags.length) && /* @__PURE__ */ jsx4(
          Carousel,
          {
            title: /* @__PURE__ */ jsx4(Typography3, { variant: "heading-L", children: section.title }),
            className: "pb-L",
            children: tags == null ? void 0 : tags.map((tagItem) => /* @__PURE__ */ jsx4(
              Button,
              {
                shape: "outlined",
                theme: "action",
                onClick: () => setSelectedTag(tagItem),
                "data-active": (selectedTag == null ? void 0 : selectedTag.id) === tagItem.id,
                className: "ltr:mr-S rtl:ml-S data-[active=false]:border-action/20 data-[active=false]:text-action/50 shrink-0",
                children: /* @__PURE__ */ jsx4(Typography3, { variant: "label-M", children: tagItem.title })
              },
              tagItem.id
            ))
          }
        ),
        desktopImage && /* @__PURE__ */ jsx4(
          ContentfulMedia_default,
          {
            media: desktopImage,
            poster: desktopImage == null ? void 0 : desktopImage.url,
            className: "hidden h-full w-full object-cover sm:block",
            autoPlay: true,
            muted: true,
            loop: true,
            playsInline: true,
            ratio: "3x1",
            placeholder: true
          }
        ),
        mobileImage && /* @__PURE__ */ jsx4(
          ContentfulMedia_default,
          {
            media: mobileImage,
            poster: mobileImage == null ? void 0 : mobileImage.url,
            className: "h-full w-full object-cover sm:hidden",
            ratio: "1x1",
            autoPlay: true,
            muted: true,
            loop: true,
            playsInline: true,
            placeholder: true
          }
        )
      ]
    }
  );
};
var HeroImage_default = HeroImage;

// src/components/hero/HeroLogo.tsx
import { Typography as Typography4 } from "@wbk/ui";
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var HeroLogo = ({ section }) => {
  const card = section.contentCollection.items[0];
  const logo = section.logo;
  const otherLinks = section.webLinksCollection.items.filter((link) => link.id !== "share");
  if (!card || !logo) return null;
  const desktopImage = card.image31 || card.background;
  const mobileImage = card.image11 || card.background;
  return /* @__PURE__ */ jsx5(DecoratedSection_default, { section, children: /* @__PURE__ */ jsxs5("div", { className: "relative", children: [
    desktopImage && /* @__PURE__ */ jsx5(
      ContentfulMedia_default,
      {
        className: "relative inset-0 hidden aspect-[4/1] w-full object-cover md:block",
        media: desktopImage,
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        ratio: "3x1",
        placeholder: true
      }
    ),
    mobileImage && /* @__PURE__ */ jsx5(
      ContentfulMedia_default,
      {
        className: "relative inset-0 block max-h-[450px] w-full object-cover md:hidden",
        media: mobileImage,
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        ratio: "1x1",
        placeholder: true
      }
    ),
    /* @__PURE__ */ jsx5(ShareContentfulButton_default, { section, type: "mini", className: "md:hidden" }),
    /* @__PURE__ */ jsxs5("div", { className: "rounded-t-L bg-body gap-L md:py-L container relative -mt-4 flex flex-col items-center justify-center md:mt-0 md:flex-row md:items-start md:justify-between md:bg-transparent", children: [
      /* @__PURE__ */ jsx5(
        ContentfulMedia_default,
        {
          media: logo,
          alt: logo == null ? void 0 : logo.title,
          width: logo == null ? void 0 : logo.width,
          height: logo == null ? void 0 : logo.height,
          className: "absolute top-0 h-24 w-24 shrink-0 -translate-y-1/2 rounded-full object-contain md:h-48 md:w-48 md:ltr:left-8 md:rtl:right-8"
        }
      ),
      /* @__PURE__ */ jsx5("div", { className: "hidden shrink-0 md:block md:h-24 md:w-48" }),
      /* @__PURE__ */ jsxs5("div", { className: "gap-L flex w-full flex-col items-center justify-between pt-16 md:flex-row md:items-start md:py-0", children: [
        /* @__PURE__ */ jsxs5("div", { className: "space-y-XS w-full text-center md:max-w-md md:text-start lg:max-w-2xl", children: [
          /* @__PURE__ */ jsx5(Typography4, { strong: true, variant: "heading-XXL", children: section.title }),
          /* @__PURE__ */ jsxs5(Typography4, { strong: true, color: "text-secondary", children: [
            section.subtitle,
            (card == null ? void 0 : card.expiresAt) && /* @__PURE__ */ jsx5("span", { className: "mx-1", children: /* @__PURE__ */ jsx5(Countdown_default, { finishDate: card.expiresAt, mini: true }) })
          ] })
        ] }),
        /* @__PURE__ */ jsx5("div", { className: "flex gap-4", children: /* @__PURE__ */ jsxs5("div", { className: "flex flex-wrap items-center justify-end gap-2 text-sm md:gap-5 md:text-base lg:flex-1 lg:justify-end", children: [
          otherLinks.map((link) => /* @__PURE__ */ jsx5(ContentfulButton_default, { link }, link.id)),
          /* @__PURE__ */ jsx5(
            ShareContentfulButton_default,
            {
              section,
              className: "gap-XS hidden border-opacity-10 md:flex"
            }
          )
        ] }) })
      ] })
    ] })
  ] }) });
};
var HeroLogo_default = HeroLogo;

// src/components/hero/HeroLeftCounter.tsx
import { Typography as Typography5 } from "@wbk/ui";
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var HeroLeftCounterSection = ({ section }) => {
  var _a, _b, _c;
  const card = (_a = section.contentCollection.items) == null ? void 0 : _a[0];
  if (!card) return null;
  const title = card == null ? void 0 : card.title;
  const subtitle = card == null ? void 0 : card.subtitle;
  const logo = card == null ? void 0 : card.image;
  const expiresAt = card == null ? void 0 : card.expiresAt;
  const expired = expiresAt && new Date(expiresAt) < /* @__PURE__ */ new Date();
  const webLinks = (_c = (_b = section == null ? void 0 : section.webLinksCollection) == null ? void 0 : _b.items) == null ? void 0 : _c.filter((link) => link.id !== "share");
  const claimer = card == null ? void 0 : card.description;
  const desktopImage = card.image31 || card.background;
  const mobileImage = card.image11 || card.background;
  return /* @__PURE__ */ jsxs6(DecoratedSection_default, { section, className: "relative !space-y-0 overflow-hidden", children: [
    desktopImage && /* @__PURE__ */ jsx6(
      ContentfulMedia_default,
      {
        media: desktopImage,
        poster: desktopImage == null ? void 0 : desktopImage.url,
        className: "absolute inset-0 -z-20 hidden h-full w-full object-cover sm:block",
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        ratio: "3x1",
        placeholder: true
      }
    ),
    mobileImage && /* @__PURE__ */ jsx6(
      ContentfulMedia_default,
      {
        media: mobileImage,
        poster: mobileImage == null ? void 0 : mobileImage.url,
        className: "absolute inset-0 -z-20 h-full w-full object-cover sm:hidden",
        ratio: "1x1",
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        placeholder: true
      }
    ),
    /* @__PURE__ */ jsxs6("div", { className: "gap-L container flex flex-col items-start justify-center", children: [
      /* @__PURE__ */ jsx6(ShareContentfulButton_default, { section, type: "mini", className: "md:hidden" }),
      logo && /* @__PURE__ */ jsx6(ContentfulMedia_default, { media: logo }),
      /* @__PURE__ */ jsxs6("div", { className: "space-y-2", children: [
        /* @__PURE__ */ jsx6(Typography5, { as: "h1", variant: "display-M", children: title }),
        subtitle && /* @__PURE__ */ jsx6(Typography5, { children: subtitle })
      ] }),
      expiresAt && !expired && /* @__PURE__ */ jsxs6("div", { className: "space-y-2", children: [
        card.buttonLabel && /* @__PURE__ */ jsx6(Typography5, { variant: "body-L", color: "text-secondary", children: card.buttonLabel }),
        /* @__PURE__ */ jsx6(Countdown_default, { finishDate: expiresAt })
      ] }),
      !!(webLinks == null ? void 0 : webLinks.length) && /* @__PURE__ */ jsxs6("div", { className: "flex w-full flex-wrap items-center gap-4", children: [
        webLinks.map((link) => /* @__PURE__ */ jsx6(
          ContentfulButton_default,
          {
            link,
            className: "min-h-[52px] w-full sm:max-w-[340px]"
          },
          link.id
        )),
        /* @__PURE__ */ jsx6(
          ShareContentfulButton_default,
          {
            section,
            className: "hidden min-h-[52px] w-full sm:max-w-[340px] md:flex"
          }
        )
      ] }),
      claimer && /* @__PURE__ */ jsx6(Typography5, { variant: "label-M", children: claimer })
    ] })
  ] });
};
var HeroLeftCounter_default = HeroLeftCounterSection;

// src/components/hero/HeroCenteredCta.tsx
import { useEffect, useRef } from "react";
import { motion } from "motion/react";
import { Paper, Typography as Typography6 } from "@wbk/ui";
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var hexToRgb = (hex) => {
  const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return match ? [parseInt(match[1], 16) / 255, parseInt(match[2], 16) / 255, parseInt(match[3], 16) / 255] : [1, 1, 1];
};
var RAYS_VERTEX_SHADER = "attribute vec2 position;varying vec2 vUv;void main(){vUv=position*0.5+0.5;gl_Position=vec4(position,0.0,1.0);}";
var RAYS_FRAGMENT_SHADER = `precision highp float;
uniform float iTime;
uniform vec2 iResolution;
uniform vec2 rayPos;
uniform vec2 rayDir;
uniform vec3 raysColor;
float noise(vec2 st){
  return fract(sin(dot(st.xy, vec2(12.9898,78.233))) * 43758.5453123);
}
float rayStrength(vec2 raySource, vec2 rayRefDirection, vec2 coord, float seedA, float seedB, float speed){
  vec2 sourceToCoord = coord - raySource;
  vec2 dirNorm = normalize(sourceToCoord);
  float cosAngle = dot(dirNorm, rayRefDirection);
  float distortedAngle = cosAngle + 0.04 * sin(iTime * 2.0 + length(sourceToCoord) * 0.01) * 0.2;
  float spreadFactor = pow(max(distortedAngle, 0.0), 1.0 / 0.9);
  float dist = length(sourceToCoord);
  float maxDistance = iResolution.x * 1.3;
  float lengthFalloff = clamp((maxDistance - dist) / maxDistance, 0.0, 1.0);
  float fadeFalloff = clamp((iResolution.x - dist) / iResolution.x, 0.5, 1.0);
  float baseStrength = clamp(
    (0.45 + 0.15 * sin(distortedAngle * seedA + iTime * speed)) +
    (0.3 + 0.2 * cos(-distortedAngle * seedB + iTime * speed)),
    0.0, 1.0
  );
  return baseStrength * lengthFalloff * fadeFalloff * spreadFactor;
}
void main(){
  vec2 coord = vec2(gl_FragCoord.x, iResolution.y - gl_FragCoord.y);
  vec4 rays1 = vec4(1.0) * rayStrength(rayPos, rayDir, coord, 36.2214, 21.11349, 1.8);
  vec4 rays2 = vec4(1.0) * rayStrength(rayPos, rayDir, coord, 22.3991, 18.0234, 1.32);
  vec4 fragColor = rays1 * 0.5 + rays2 * 0.4;
  float n = noise(coord * 0.01 + iTime * 0.1);
  fragColor.rgb *= (1.0 - 0.06 + 0.06 * n);
  float brightness = 1.0 - (coord.y / iResolution.y);
  fragColor.x *= 0.1 + brightness * 0.8;
  fragColor.y *= 0.3 + brightness * 0.6;
  fragColor.z *= 0.5 + brightness * 0.5;
  fragColor.rgb *= raysColor;
  gl_FragColor = fragColor;
}`;
var HeroRays = ({ color }) => {
  const hostRef = useRef(null);
  useEffect(() => {
    const host = hostRef.current;
    if (!host || window.matchMedia(REDUCED_MOTION).matches) return;
    const canvas = document.createElement("canvas");
    canvas.className = "block h-full w-full";
    host.appendChild(canvas);
    const gl = canvas.getContext("webgl", { alpha: true, premultipliedAlpha: false });
    if (!gl) {
      canvas.remove();
      return;
    }
    const compile = (type, source) => {
      const shader = gl.createShader(type);
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      return shader;
    };
    const program = gl.createProgram();
    gl.attachShader(program, compile(gl.VERTEX_SHADER, RAYS_VERTEX_SHADER));
    gl.attachShader(program, compile(gl.FRAGMENT_SHADER, RAYS_FRAGMENT_SHADER));
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
      canvas.remove();
      return;
    }
    gl.useProgram(program);
    const buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    const positionLoc = gl.getAttribLocation(program, "position");
    gl.enableVertexAttribArray(positionLoc);
    gl.vertexAttribPointer(positionLoc, 2, gl.FLOAT, false, 0, 0);
    const uniforms = {
      iTime: gl.getUniformLocation(program, "iTime"),
      iResolution: gl.getUniformLocation(program, "iResolution"),
      rayPos: gl.getUniformLocation(program, "rayPos"),
      rayDir: gl.getUniformLocation(program, "rayDir"),
      raysColor: gl.getUniformLocation(program, "raysColor")
    };
    gl.uniform3fv(uniforms.raysColor, hexToRgb(color));
    const placement = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.max(1, host.clientWidth * dpr);
      canvas.height = Math.max(1, host.clientHeight * dpr);
      gl.viewport(0, 0, canvas.width, canvas.height);
      gl.uniform2f(uniforms.iResolution, canvas.width, canvas.height);
      gl.uniform2f(uniforms.rayPos, 0.5 * canvas.width, -0.2 * canvas.height);
      gl.uniform2f(uniforms.rayDir, 0, 1);
    };
    const resizeObserver = new ResizeObserver(placement);
    resizeObserver.observe(host);
    placement();
    let raf = 0;
    const frame = (time) => {
      gl.uniform1f(uniforms.iTime, time * 1e-3);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      raf = requestAnimationFrame(frame);
    };
    const intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (!raf) raf = requestAnimationFrame(frame);
        } else if (raf) {
          cancelAnimationFrame(raf);
          raf = 0;
        }
      },
      { threshold: 0.05 }
    );
    intersectionObserver.observe(host);
    return () => {
      if (raf) cancelAnimationFrame(raf);
      resizeObserver.disconnect();
      intersectionObserver.disconnect();
      canvas.remove();
    };
  }, [color]);
  return /* @__PURE__ */ jsx7(
    "div",
    {
      ref: hostRef,
      "aria-hidden": true,
      className: "pointer-events-none absolute inset-0 z-0 overflow-hidden"
    }
  );
};
var HeroCenteredCta = ({ section }) => {
  var _a;
  const card = (_a = section.contentCollection.items) == null ? void 0 : _a[0];
  const links = section.webLinksCollection.items;
  return /* @__PURE__ */ jsxs7(DecoratedSection_default, { section, children: [
    (card == null ? void 0 : card.color) && /* @__PURE__ */ jsx7(HeroRays, { color: card.color }),
    /* @__PURE__ */ jsx7("div", { className: "container relative z-10 flex flex-col items-center justify-center text-center", children: /* @__PURE__ */ jsxs7("div", { className: "space-y-6", children: [
      (card == null ? void 0 : card.image) && /* @__PURE__ */ jsx7(
        motion.div,
        {
          initial: { opacity: 0, y: 26 },
          whileInView: { opacity: 1, y: 0 },
          viewport: { once: true, amount: 0.2 },
          transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
          children: /* @__PURE__ */ jsx7(ContentfulMedia_default, { media: card.image, className: "mx-auto" })
        }
      ),
      (section.logo || section.collapsableDescription) && /* @__PURE__ */ jsx7(
        motion.div,
        {
          initial: { opacity: 0, y: 26 },
          whileInView: { opacity: 1, y: 0 },
          viewport: { once: true, amount: 0.2 },
          transition: { duration: 0.7, delay: 0.16, ease: [0.16, 1, 0.3, 1] },
          className: "flex justify-center",
          children: /* @__PURE__ */ jsxs7(
            Paper,
            {
              border: true,
              surface: "level-1",
              size: "S",
              className: "flex items-center gap-2 rounded-full",
              rounded: false,
              children: [
                section.logo && /* @__PURE__ */ jsx7(ContentfulMedia_default, { media: section.logo, className: "h-4 w-auto shrink-0" }),
                /* @__PURE__ */ jsx7(Typography6, { variant: "label-S", color: "text-secondary", children: section.collapsableDescription && /* @__PURE__ */ jsx7(ContentfulRichText_default, { description: section.collapsableDescription }) })
              ]
            }
          )
        }
      ),
      /* @__PURE__ */ jsx7(
        motion.div,
        {
          initial: { opacity: 0, y: 26 },
          whileInView: { opacity: 1, y: 0 },
          viewport: { once: true, amount: 0.2 },
          transition: { duration: 0.7, delay: 0.32, ease: [0.16, 1, 0.3, 1] },
          children: /* @__PURE__ */ jsx7(Typography6, { as: "h2", variant: "display-M", strong: true, children: section.title })
        }
      ),
      section.subtitle && /* @__PURE__ */ jsx7(
        motion.div,
        {
          initial: { opacity: 0, y: 26 },
          whileInView: { opacity: 1, y: 0 },
          viewport: { once: true, amount: 0.2 },
          transition: { duration: 0.7, delay: 0.48, ease: [0.16, 1, 0.3, 1] },
          children: /* @__PURE__ */ jsx7(Typography6, { variant: "body-M", color: "text-secondary", children: section.subtitle })
        }
      ),
      !!links.length && /* @__PURE__ */ jsx7(
        motion.div,
        {
          initial: { opacity: 0, y: 26 },
          whileInView: { opacity: 1, y: 0 },
          viewport: { once: true, amount: 0.2 },
          transition: { duration: 0.7, delay: 0.64, ease: [0.16, 1, 0.3, 1] },
          className: "flex flex-wrap items-center justify-center gap-2",
          children: links.map((link) => /* @__PURE__ */ jsx7(ContentfulButton_default, { link }, link.id))
        }
      )
    ] }) })
  ] });
};
var HeroCenteredCta_default = HeroCenteredCta;

export {
  HeroSection_default,
  HeroCounter_default,
  HeroGrid_default,
  HeroImage_default,
  HeroLogo_default,
  HeroLeftCounter_default,
  HeroCenteredCta_default
};
//# sourceMappingURL=chunk-FBV3GEXL.mjs.map